module.exports = __webpack_public_path__ + "images/index/img06.492b4e2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/intro/EDU/img06.jpg
// module id = 1t3f
// module chunks = 21